import { Controller } from "@hotwired/stimulus"

// FIXME:
// add step
// check minvalue

export default class extends Controller {
  static values = {
    precision: Number,
    min: Number,
    incrementStep: Number,
    fixed: Boolean
  }

  hidden_field = null;
  re = null;

  connect() {
    if (this.precisionValue === 0) {
      this.re = new RegExp("^\\d*$")
    } else {
      this.re = new RegExp("^\\d*,?\\d{0," + this.precisionValue + "}$")
    }
    this.hidden_field = document.createElement("input");
    this.hidden_field.type = "hidden";
    this.hidden_field.name = this.element.name;
    this.hidden_field.value = this.element.value;
    this.element.after(this.hidden_field);
    if (this._isNumeric(this.element.value)) {
      if (this.fixedValue) {
        this.element.value = parseFloat(this.element.value).toFixed(this.precisionValue);
      } else {
        this.element.value = parseFloat(this.element.value).toString();
      }
    }
    this.element.value = this.element.value.replace(".", ",");
    this.element.defaultValue = this.element.value; // to fix wrong value issue after form reset
    this.element.setAttribute("data-name", this.element.name);
    this.element.name = "";
  }

  increment(event) {
    const current = parseFloat(this.hidden_field.value) || 0;
    const updated = this.toDecimal(current + this.incrementStepValue);

    this.hidden_field.value = updated;
    this.element.value      = this.toDisplayValue(updated);
    this.element.dispatchEvent(new Event("change", { bubbles: true }));
  }

  decrement(event) {
    const current = parseFloat(this.hidden_field.value) || 0;
    const updated = this.toDecimal(current - this.incrementStepValue)
    if (updated < this.minValue) return;

    this.hidden_field.value = updated;
    this.element.value      = this.toDisplayValue(updated);
    this.element.dispatchEvent(new Event("change", { bubbles: true }));
  }

  toDecimal(number) {
    return parseFloat(number.toFixed(this.precisionValue));
  }

  toDisplayValue(number) {
    if (this.fixedValue) {
      return number.toFixed(this.precisionValue).replace(".", ",");
    } else {
      return number.toString().replace(".", ",");
    }
  }

  update(event) {
    // check for invalid pasted value?
    event.target.value = event.target.value.trim();
    if (!this.is_valid(event.target.value)) {
      event.target.value = this.hidden_field.value.replace(".", ",");
    }
    this.hidden_field.value = event.target.value.replace(",", ".");
  }

  input(event) {
    if (event.ctrlKey) return; // pass ctrl modifier
    if (event.key.length > 1) return; // other special keys (up, down, etc.)

    const input = event.target;
    const value = input.value;
    const start = input.selectionStart;
    const end = input.selectionEnd;
    const new_value = value.slice(0, start) + event.key + value.slice(end);

    if (!this.is_valid(new_value)) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }

  // private
  is_valid(value) {
    if (value.length === 0) return true;
    return value.match(this.re);
  }

  _isNumeric(value) {
    return !isNaN(parseFloat(value)) && isFinite(value);
  }
}
